import { useEffect, useState } from 'react';

/**
 * useIsMobile — true quando a viewport está abaixo do breakpoint do shell (lg=1024,
 * mockups usam max-width:899/1023 conforme a tela). Usa matchMedia com listener
 * (sem resize thrash). Default do query = 1023px (mesmo corte do Chat/shell mobile).
 *
 * @param maxWidth largura máxima em px para considerar "mobile" (default 1023)
 */
export function useIsMobile(maxWidth = 1023): boolean {
  const query = `(max-width: ${maxWidth}px)`;
  const [isMobile, setIsMobile] = useState<boolean>(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    setIsMobile(mq.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [query]);

  return isMobile;
}
